import { array, boolean, number, object, string } from 'yup';

const emailValidation =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^ <>()[\]\\., ;: \s @"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const phoneValidation = /^01[0-2,5]{1}[0-9]{8}$/;

/**
 * A dropdown id that may legitimately be unset. An empty select yields '' and a
 * cleared Autocomplete yields null/undefined; number() turns the first into NaN
 * and would then fail with a type error, so normalise all three to null.
 */
const optionalId = () =>
	number()
		.transform((value, original) =>
			original === '' ||
			original === null ||
			original === undefined ||
			Number.isNaN(value)
				? null
				: value
		)
		.nullable(true);

export const INFO_SCHEMA = object({
	first_name: string().required(),
	last_name: string().required(),
	// Display-only in the form, so it must never be able to block a save.
	username: string().nullable(true),
	birth_date: string().nullable(true),
	email: string()
		.nullable(true)
		.transform((v) => (v === '' ? null : v))
		.matches(emailValidation, {
			message: 'E-mail is not valid',
			excludeEmptyString: true,
		}),
	gender: string().nullable(true),
	phone_verified: boolean().notRequired(),
	student: object({
		// Same reasoning as `address` below. These also get cleared to '' by the
		// cascade effects in EditStudentForm (picking a diploma resets the year),
		// which number() would otherwise turn into a NaN type error.
		education_type_id: optionalId().min(1, 'Field Required'),
		education_year_id: optionalId().min(1, 'Field Required'),
		education_language_id: optionalId().min(1, 'Field Required'),
		education_section_id: optionalId(),
		profile_complete: boolean().notRequired(),
		registration_paid: boolean().notRequired(),
		// parent_phone: string().matches(phoneValidation, "must be 01xxxxxxxx"),
		parent_phone: string()
			.matches(phoneValidation, 'must be 01xxxxxxxx')
			.nullable(true)
			.transform((v, o) => (v === '' ? null : v)),
		parent_relation: string().nullable(true),
		school: string().nullable(true),
		// Nothing here is required. An admin editing a student is not the same as
		// a student completing their own profile — the API asks only for `uuid`
		// (StudentUpdateValidator), so demanding a governorate here blocked
		// unrelated edits (e.g. flipping a toggle) on every half-registered
		// student. Format rules are kept; presence rules are not.
		address: object({
			governorate: optionalId(),
			city: optionalId(),
		}).default(undefined),
	}),
	phone_number: string()
		.matches(phoneValidation, 'must be 01xxxxxxxx')
		.required(),
});
